import { Link } from 'react-router-dom';

const items = [
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    rating: 8.9,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20giant%20planet%20and%20spaceship%2C%20dramatic%20warm%20orange%20and%20teal%20cinematic%20lighting%2C%20epic%20scale%2C%20movie%20poster%20style%2C%20clean%20background%2C%20professional%20cinematic%20rendering%2C%20atmospheric%20and%20grand&width=400&height=600&seq=hot-1&orientation=portrait',
    badge: '热播',
    link: '/category/movie',
  },
  {
    id: 2,
    title: '狂飙',
    category: '电视剧',
    rating: 9.1,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20scene%20with%20intense%20atmosphere%2C%20dark%20urban%20setting%2C%20dramatic%20warm%20lighting%2C%20TV%20series%20poster%20style%2C%20professional%20photography%2C%20moody%20and%20suspenseful%2C%20clean%20composition&width=400&height=600&seq=hot-2&orientation=portrait',
    badge: '热播',
    link: '/category/tv',
  },
  {
    id: 3,
    title: '奔跑吧第十季',
    category: '综艺',
    rating: 8.5,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20outdoor%20scene%20with%20bright%20sunlight%2C%20energetic%20group%20activity%2C%20colorful%20warm%20tones%2C%20cheerful%20atmosphere%2C%20professional%20broadcast%20photography%2C%20clean%20and%20vibrant%20composition&width=400&height=600&seq=hot-3&orientation=portrait',
    badge: '热播',
    link: '/category/variety',
  },
  {
    id: 4,
    title: '庆余年第二季',
    category: '电视剧',
    rating: 9.3,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20with%20elegant%20palace%20setting%2C%20warm%20golden%20hour%20lighting%2C%20artistic%20composition%2C%20cinematic%20style%2C%20rich%20textures%2C%20professional%20TV%20series%20poster%20aesthetic&width=400&height=600&seq=hot-4&orientation=portrait',
    badge: '热播',
    link: '/category/tv',
  },
  {
    id: 5,
    title: '封神第二部',
    category: '电影',
    rating: 8.7,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20scene%20with%20epic%20battle%2C%20dramatic%20warm%20fire%20and%20gold%20lighting%2C%20cinematic%20scale%2C%20professional%20movie%20poster%20style%2C%20grand%20and%20atmospheric%2C%20clean%20background&width=400&height=600&seq=hot-5&orientation=portrait',
    badge: '新片',
    link: '/category/movie',
  },
  {
    id: 6,
    title: '王牌对王牌第八季',
    category: '综艺',
    rating: 8.3,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Studio%20variety%20show%20with%20colorful%20stage%20lighting%2C%20warm%20and%20vibrant%20atmosphere%2C%20entertainment%20setting%2C%20professional%20photography%2C%20cheerful%20mood%2C%20clean%20composition%2C%20bright%20coral%20and%20golden%20accents&width=400&height=600&seq=hot-6&orientation=portrait',
    badge: '更新',
    link: '/category/variety',
  },
  {
    id: 7,
    title: '繁花',
    category: '电视剧',
    rating: 9.0,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20nostalgic%20drama%20scene%20with%20warm%20vintage%20lighting%2C%20elegant%201990s%20aesthetic%2C%20cinematic%20composition%2C%20rich%20golden%20tones%2C%20professional%20TV%20series%20poster%2C%20atmospheric%20and%20stylish&width=400&height=600&seq=hot-7&orientation=portrait',
    badge: '高分',
    link: '/category/tv',
  },
  {
    id: 8,
    title: '熊出没·逆转时空',
    category: '动漫',
    rating: 8.6,
    year: 2024,
    imageUrl: 'https://readdy.ai/api/search-image?query=3D%20animated%20family%20movie%20scene%20with%20forest%20setting%2C%20warm%20sunlight%2C%20cute%20bear%20characters%2C%20vibrant%20colors%2C%20cinematic%20animation%20style%2C%20cheerful%20and%20adventurous%20mood%2C%20clean%20composition&width=400&height=600&seq=hot-8&orientation=portrait',
    badge: '新片',
    link: '/category/anime',
  },
];

export default function HotRecommendations() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-600 mt-1">
            大家都在看的精彩内容
          </p>
        </div>
        <Link
          to="/category/movie"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium no-underline whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {items.map((item) => (
          <Link
            key={item.id}
            to={item.link}
            className="group no-underline"
          >
            <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
              <img
                src={item.imageUrl}
                alt={item.title}
                title={`${item.title} - 糖豆视频高清在线观看`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-medium">
                  {item.badge}
                </span>
              </div>
              <div className="absolute top-2 right-2 flex items-center gap-1 px-1.5 py-0.5 rounded bg-foreground-950/70 text-background-50 text-[10px]">
                <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                {item.rating}
              </div>
            </div>
            <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
              {item.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">
              {item.category} · {item.year}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}